import { createSelector } from 'reselect';
import get from 'lodash/get';

const selectAuthState = state => get(state, 'auth');

export const selectAuthStatus = createSelector(
  selectAuthState,
  state => get(state, 'status'),
);

export const selectAuthStatusRedirectTo = createSelector(
  selectAuthStatus,
  state => get(state, 'redirectTo'),
);

export const selectAuthStatusInvitationType = createSelector(
  selectAuthStatus,
  state => get(state, 'invitationType'),
);

export const selectUserRegistration = createSelector(
  selectAuthState,
  state => get(state, 'generalUserRegistrations'),
);

export const selectUserRegistrationErrors = createSelector(
  selectUserRegistration,
  state => get(state, 'error'),
);

export const selectAuthStatusInvitationMethod = createSelector(
  selectAuthStatus,
  state => get(state, 'invitationMethod'),
);

export const selectSignupProcess = createSelector(
  selectAuthState,
  auth => get(auth, 'signupProcess'),
);

export const selectSignupProcessFormData = createSelector(
  selectSignupProcess,
  state => get(state, 'signupFormData'),
);

export const selectSignupPersonalInfoFormData = createSelector(
  selectSignupProcess,
  state => get(state, 'personalInfoFormData') || {},
);

export const selectIsSignupFormDataEmpty = createSelector(
  selectSignupProcessFormData,
  data => !data,
);

export const selectSignUpAzureFlow = createSelector(
  selectAuthStatus,
  state => get(state, 'isSignUpAzureFlow'),
);

export const selectUsernameAvailabilityError = createSelector(
  selectAuthState,
  state => get(state, 'usernameAvailability.error', false),
);



// WEBPACK FOOTER //
// ./src/redux/auth/signup/selectors.js